const state = {
  userInfo: null,
  persons: []
}

const mutations = {
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
    state.persons = userInfo?.persons || []
  }
}

const actions = {
  updateUserInfo({ commit }, userInfo) {
    commit('SET_USER_INFO', userInfo)
  }
}

const getters = {
  persons: state => state.persons
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
